import { useCallback, useEffect, useMemo, useState } from "react";
import "./lightBox.scss";


export const LightBox = (props) => {
  //Open lightbox
const [galleryData, setGalleryData] = useState(null);

  const openGallery = () => {
    setGalleryData(props.slides);
  };
  const closeGallery = () => {
    setGalleryData(null);
  }

  const slides = useMemo(() => {
    return (props.slides && props.slides.length > 0 && props.slides.map((video) => <div dangerouslySetInnerHTML={{ __html: video.preview }}></div>));
  }, [JSON.stringify(props.slides)]);

  const gallery = useMemo(() => {
    return <LightBoxPopup closeGallery={closeGallery} slides={slides} />;
  }, [galleryData]);

  return <div className='c-content-block c-gallery-fiche-videos'>
    <div className='media-fiche-gallery'>
      <a className="c-gallery-lightbox-link" onClick={() => openGallery()}>
        <div className="play-button"></div>
        <img src={props.thumbnail} />
        <div className="image-overlay">
          {props.slides.length >= 2 ? "+ " + (props.slides.length - 1).toString() + " video" + (props.slides.length - 1 >= 2 ? "'s" : "") : ""}
        </div>
      </a>
    </div>
    {galleryData && gallery}
  </div>;
}

const LightBoxPopup = (props) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [content, setContent] = useState(null);

  useEffect(() => {
    setContent(props.slides[currentSlide]);
  }, [currentSlide])

  const prev = () => {
    if (currentSlide === 0) {
      setCurrentSlide(props.slides.length - 1)
    }
    else {
      setCurrentSlide(currentSlide - 1)
    }
  };

  const next = () => {
    if (currentSlide === props.slides.length - 1) {
      setCurrentSlide(0)
    }
    else {
      setCurrentSlide(currentSlide + 1)
    }
  };

  return (
    <div className="lightboxContainer">
      <div id="lightboxOverlay" className="lightboxOverlay"></div>
      <div id="lightbox" className="lightbox" onClick={(evt) => (
        props.closeGallery
        && ((evt.target.classList.value.includes("lightbox")
          || evt.target.classList.value.includes("lb-outerContainer"))
          && props.closeGallery())
        )}>
        <div className="lb-outerContainer">
          <div className="lb-container c-gallery-videos">
            <div className="lb-nav">
              {content}
              {props.slides.length > 1 && 
                <div className="lb-nav-arrows">
                  <a className="lb-prev back" onClick={() => prev()}>
                    <i className="fa fa-arrow-left"></i>
                  </a>
                  <a className="lb-next next" onClick={() => next()}>
                    <i className="fa fa-arrow-right"></i>
                  </a>
                </div>
              }              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}